import g from "./index.es473.js";
function u(o) {
  var c = o.sheetId, a = o.orientation, t = "";
  if (a) {
    var r = 0.7, n = 0.7, e = 0.75, i = 0.75, p = 0.3, f = 0.3;
    t += "<pageMargins", t += ' left="'.concat(r, '"'), t += ' right="'.concat(n, '"'), t += ' top="'.concat(e, '"'), t += ' bottom="'.concat(i, '"'), t += ' header="'.concat(p, '"'), t += ' footer="'.concat(f, '"'), t += "/>";
  }
  if (a) {
    var d = 9;
    t += "<pageSetup", t += ' paperSize="'.concat(d, '"'), t += ' orientation="'.concat(g(a), '"'), t += ' r:id="rId'.concat(c, '"'), t += "/>";
  }
  return t;
}
export {
  u as default
};
//# sourceMappingURL=index.es504.js.map
